import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/location_new//toronto/crafting_back.webp";
import { Link } from "gatsby";

function Dynamichouston() {
  return (
    <section
      className="dynamic_houston p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto resp_order"
          >
            <StaticImage
              src="../../../images/location_new/toronto/crafting_toronto.webp"
              alt="mobile app development development company in Toronto"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={486}
              height={651}
            />
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Crafting Next-gen Solutions with Our App Developers in Toronto
            </h2>
            <p>
              We have the finest designers and app developers in Toronto,
              specializing in building both native and cross-platform mobile
              apps with intuitive design, flawless efficiency, fail-proof
              security, and options to scale. Our expert team prefers the latest
              technology to craft user-centric app solutions that are superfast
              and feature-packed. Whether you want to build an app from scratch
              or optimize it in terms of speed, accuracy, functionality, user
              interface, and design aesthetics, we have the right resources to
              handle your requirements.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Dynamichouston;
